import { useLayoutEffect } from 'react';
import { Loading } from '@repo/ui';
import { getPlatformAppsUrl } from '../config/app.config';

/**
 * Yerel ERP giriş sayfası yok; `/`, `/erp`, `/apps`, `/qubepro` → merkezi uygulama listesi (VITE_PLATFORM_APPS_URL).
 */
export default function RedirectToPlatformApps() {
  useLayoutEffect(() => {
    window.location.replace(getPlatformAppsUrl());
  }, []);
  return <Loading fullScreen />;
}
